// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__MubIe","footer__text":"footer_footer__text__Kr+5g"};